import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { LoadingButton } from "../components/Spinner";
import PasswordInput from "../components/PasswordInput";
import { useToast } from "../components/Toast";

export default function ResetPassword() {
  const { token = "" } = useParams();
  const nav = useNavigate();
  const qc = useQueryClient();
  const toast = useToast();
  const [password, setPassword] = useState("");

  const reset = useMutation({
    mutationFn: () => api.resetPassword(token, password),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["me"] });
      nav("/");
    },
    onError: (e) => toast.error(parseErr(e)),
  });

  return (
    <div className="relative grid h-full place-items-center bg-bg p-6 overflow-hidden">
      <div className="auth-glow" aria-hidden="true" />
      <div className="card auth-card max-w-md w-full p-8 space-y-5 relative">
        <h1 className="text-xl font-semibold text-center">Choose a new password</h1>
        <form
          className="space-y-3"
          onSubmit={(e) => { e.preventDefault(); reset.mutate(); }}
        >
          <PasswordInput
            required
            minLength={8}
            placeholder="New password (8+ chars)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            autoFocus
          />
          <LoadingButton
            type="submit"
            className="btn-primary w-full justify-center"
            pending={reset.isPending}
            pendingLabel="Resetting…"
          >
            Reset password
          </LoadingButton>
        </form>
      </div>
    </div>
  );
}

function parseErr(e: unknown): string {
  const m = String((e as Error).message ?? "");
  if (m.includes("invalid_token")) return "This reset link is invalid or has expired.";
  if (m.includes("bad_input")) return "Password must be at least 8 characters.";
  return "Couldn't reset your password.";
}
